import styles from "./HighlightedReview.module.scss";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "jl-reviews-highlight-review": {
        "data-testid"?: string;
        productId: string;
        apiKey: string;
        clientId: string;
        defaultSort: string;
        additionalId?: string;
        isBrandPromiseActive: boolean;
        experiments: string;
      };
    }
  }
}

type Props = {
  /**
   * A string representing the product ID.
   */
  productId: string;
  /**
   * A string representing the API key.
   */
  apiKey: string;
  /**
   * A string representing the client ID.
   */
  clientId: string;
  /**
   * A string representing the raw experiences
   */
  experiencesRawString: string;
};

export const HighlightedReviewUI = ({
  productId,
  apiKey,
  clientId,
  experiencesRawString,
}: Props) => (
  <div
    className={styles.container}
    data-testid="highlighted:review"
    id="standardPDPHighlightedReview"
  >
    <jl-reviews-highlight-review
      productId={productId}
      apiKey={apiKey}
      clientId={clientId}
      defaultSort="newest"
      additionalId="fashion"
      isBrandPromiseActive={true}
      experiments={experiencesRawString}
    />
  </div>
);
